import * as React from 'react';

import FileNumbers16 from './FileNumbers16';

export const fileNumbers16 = () => <FileNumbers16 />;

export default {
    title: 'Icon/Fill/FileNumbers16',
    component: FileNumbers16,
    parameters: {
        notes: "`import FileNumbers16 from 'box-ui-elements/es/icon/fill/FileNumbers16';`",
    },
};
